export const TEXT_FIELD_ID = '&text&';

export const UNITS = {
  Meter: 1,
  Inch: 2,
  'Cubic meter': 3,
  'Cubic Inch': 4,
  Kilogram: 5,
  Pound: 7,
  'Cubic Meter': 9,
  Quantity: 10,
  Minutes: 14,
  'Cubic Feet': 19,
} as const;

export const DEFAULT_UNITS_BY_MAGNITUDE = {
  // length
  1: {
    us: UNITS.Inch,
    metric: UNITS.Meter,
  },
  // weight
  2: {
    us: UNITS.Pound,
    metric: UNITS.Kilogram,
  },
  // time
  3: {
    us: UNITS.Minutes,
    metric: UNITS.Minutes,
  },
  // volume
  4: {
    us: UNITS['Cubic Inch'],
    metric: UNITS['Cubic meter'],
  },
  // volume
  5: {
    us: UNITS['Cubic Meter'],
    metric: UNITS['Cubic Meter'],
  },
  // quantity
  6: {
    us: UNITS.Quantity,
    metric: UNITS.Quantity,
  },
} as const;
